import { observable, action, computed, makeObservable } from 'mobx';
import WorkflowNotificationsSocket from "./WorkflowNotificationsSocket"
import defaultSessionStore from "../session/SessionStore";
import workflowNotificationsApi from './WorkflowNotificationsApi'
import {ToastService} from "../../components/toasts/Toasts";
import formatNotification from "./NotificationFormatter"
import React from "react"
import moment from 'moment'
import _ from 'lodash'

export class WorkflowNotificationsStore {

  pageSize = 10

  isInitializing = false;

  isLoading = false;

  hasMore = true;

  settings = {};

  notifications = [];

  get unreadBadge() {
    // doesn't know about notifications not yet loaded, so show a generic thing after 10
    return this.countUnread >= 10 ? "!" : this.countUnread.toString()
  }

  get countUnread() {
    // doesn't know about notifications not yet loaded
    return this.notifications.filter(n => n.viewed === false).length
  }

  constructor() {
    makeObservable(this, {
      isInitializing: observable,
      isLoading: observable,
      hasMore: observable,
      settings: observable,
      notifications: observable,
      countUnread: computed,
      init: action.bound,
      loadMore: action.bound,
      addNotification: action,
      markAllViewed: action
    });
  }
  init() {
    this.isInitializing = true;
    this.socket = new WorkflowNotificationsSocket(defaultSessionStore);
    this.socket.onMessage((msg) => {
      const initialized = this.addNotification(msg, false)

      // I don't love having this in here, but I've gone so far from architectural ideals that at this point
      // I'm just trying to get it to work for now
      const formatted = formatNotification(initialized)
      ToastService.info(<a href={formatted.link} className={"notification-toast"}>{formatted.detail}</a>)
    })
    this.api = workflowNotificationsApi;
    const settingsRequest = this.api.getNotificationSettings().then(settings => {
      this.settings = {
        ...settings,
        lastViewedTimestamp: settings.lastViewedNotifications ?
          moment(settings.lastViewedNotifications).toDate().getTime() : 0
      }
    }).then(this.loadMore);
  }

  loadMore() {
    if (this.isLoading || !this.hasMore) return;

    this.isLoading = true
    this.api.listNotifications({offset: this.notifications.length, limit: this.pageSize})
      .then(action("updateLoading", notifications => {
        notifications.forEach(n => this.addNotification(n, true))
          this.isLoading = false
          this.hasMore = notifications.length === this.pageSize
      }))
  }

  addNotification(notification, append = true) {
    const initialized = this.initializeNotification(notification)
    this.notifications[append ? 'push' : 'unshift'](initialized)
    return initialized
  }

  markAllViewed() {
    this.notifications.map(item => item.viewed = true)
    this.api.markNotificationsViewed()
  }

  initializeNotification(notification) {
    const date = moment(notification.timestamp)
    return {
      ...notification,
      date: date,
      viewed: date.toDate().getTime() < this.settings.lastViewedTimestamp
    }
  }

}

export default new WorkflowNotificationsStore()
